module.exports = "<div class=\"adSense\" *ngIf=\"isVisible\">\n    <div class=\"adSense-transparent\"></div>\n    <ng2-adsense [display]=\"'block'\"></ng2-adsense>\n    <div class=\"adSense-close glyphicon glyphicon-remove\" (click)=\"toggleVisibility()\"></div>\n</div>";


//////////////////
// WEBPACK FOOTER
// ./src/app/components/adSense/adSense.component.html
// module id = 786
// module chunks = 0